export function getMonthList(locales?: string | string[]): string[] {
  const formatter = new Intl.DateTimeFormat(locales, {
    month: 'long',
  });

  return Array.from(Array(12).keys()).map(getMonthName);

  function getMonthName(index: number) {
    return formatter.format(new Date(2023, index));
  }
}
